<template>
    <div class="date-group">
      <label>{{ groupLabel }}</label>
        <input
            type="hidden"
            :name="name"
            :value="value"
        >
          <select
                name="day"
                class="form-control day"
                v-model="day"
                :disabled="disabled"
          >
            <option disabled value="" selected="selected">--{{ dayLabel }}--</option>
            <option v-for="option in dayOptions" v-bind:value="option.value">
              {{ option.label }}
            </option>
          </select>
        <select
            name="month"
            class="form-control month"
            v-model="month"
            :disabled="disabled"
        >
          <option disabled value="" selected="selected">--{{ monthLabel }}--</option>
          <option v-for="option in monthOptions" v-bind:value="option.value">
            {{ option.label }}
          </option>
        </select>
        <select
            name="year"
            class="form-control year"
            v-model="year"
            :disabled="disabled"
        >
          <option disabled value="" selected="selected">--{{ yearLabel }}--</option>
          <option v-for="option in yearOptions" v-bind:value="option.value">
            {{ option.label }}
          </option>
        </select>
    </div>
</template>

<script>
import _ from "lodash";

export default {
    props: {
        name: {
            required: true
        },
        groupLabel: {
          type: String,
          default: 'Date of Birth (DD/MM/YYYY)'
        },
        defaultValue: {
          type: Array,
          default: []
        },
        disabled: {
            default: false
        },
        old: ''
    },
    computed: {
        value() {
            if(this.day && this.month && this.year) {
                return `${this.day}/${this.month}/${this.year}`
            } else {
              const self = this
              _.each(this.defaultValue, function (data) {
                if( self.name === data.key ) {
                  self.date = data.date
                }
              })
              return this.date
            }
        },
      dayOptions() {
          let dayOptions = []
          for(let day = 1;day<=31;day++) {
            dayOptions[day-1] = {label:day,value:day}
          }
          return dayOptions
      },
      yearOptions() {
          let yearOptions = []
          let today = new Date()
          let year = today.getFullYear()
          let count = 0
          for(let startYear=year-100;startYear<=year;startYear++) {
            yearOptions[count] = {label:startYear,value:startYear}
            count++
          }
          return yearOptions
      }
    },
    data() {
        return {
            day: this.old['day'] ? this.old['day'] : '',
            month: this.old['month'] ? this.old['month'] : '',
            year: this.old['year'] ? this.old['year'] : '',
            date: this.old['date'] ? this.old['date'] : '',
            monthOptions: [{label:'January',value: 1},{label:'February',value: 2},
                           {label:'March',value: 3},{label:'April',value: 4},
                           {label:'May',value: 5},{label:'June',value: 6},
                           {label:'July',value: 7},{label:'August',value: 8},
                           {label:'September',value: 9},{label:'October',value: 10},
                           {label:'November',value: 11},{label:'December',value: 12}],
            bootstrap: true,
            dayLabel: 'Day',
            monthLabel: 'Month',
            yearLabel: 'Year',
            error: '',
        }
    },
    mounted() {
      // set up the default value of the widget
      const self = this
      _.each(this.defaultValue, function (data) {
          if( self.name === data.key ) {
            self.day = data.day
            self.month = data.month
            self.year = data.year
          }
      })
        // we don't want to focus any elements on page load
        // so we use the bootstrap property to signal whether
        // this is the first load, or later
        this.$nextTick(() => {
            this.bootstrap = false
        })
    }
}
</script>
